// extracted by mini-css-extract-plugin
export default {"slider":"ScrollSnapSlider_slider__hmahc","footer":"ScrollSnapSlider_footer__aUGGp","controls":"ScrollSnapSlider_controls__q6ntM"};